import {useRoute} from "vue-router";
import {nextTick, onMounted, watch} from "vue";

/**
 * Composable to handle scrolling to an element asynchronously based on the route query parameter.
 * It attempts to scroll to the specified element multiple times if it is not immediately found.
 */
const useAsyncScrollTo = () => {
    const route = useRoute();

    /**
     * Scrolls to the specified element by its ID.
     * @param elementId
     * @param maxAttempts
     * @param delay
     */
    const scrollToElement = async (elementId: string, maxAttempts = 10, delay = 500) => {
        for (let i = 0; i < maxAttempts; i++) {

            const element = document.getElementById(elementId);
            if (element) {

                element.scrollIntoView({behavior: 'smooth', block: 'center'});
                return true;
            }
            await new Promise(resolve => setTimeout(resolve, delay));
        }
        return false;
    };

    onMounted(async () => {
        if (route.query.scrollTo) {
            await nextTick();
            await scrollToElement(route.query.scrollTo as string);
        }
    });

    watch(() => route.query.scrollTo, async (newScrollTo) => {
        if (newScrollTo) {
            await nextTick();
            await scrollToElement(newScrollTo as string);
        }
    });
};

export default useAsyncScrollTo;
